module.exports = __webpack_public_path__ + "static/media/img1-3.fc0bdfab.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/banano/nutricheck_suelo/CA/img1-3.png
// module id = 1206
// module chunks = 3